import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function ForgotPasswordPage() {
  const auth = useAuth();
  const [email, setEmail] = React.useState('');
  const [submitted, setSubmitted] = React.useState(false);
  const [error, setError] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  if (auth && auth.isAuthenticated) { if (typeof window !== 'undefined') window.location.href = '/app/'; return null; }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      if (res.ok) {
        setSubmitted(true);
      } else {
        setError(data.error || 'Something went wrong.');
      }
    } catch {
      setError('Connection error. Please try again.');
    }
    setLoading(false);
  };

  if (submitted) {
    return (
      <div className="auth-page" style={{ backgroundColor: '#FFFFFF' }}>
        <div className="auth-card">
          <h1 style={{ color: '#000' }}>Check your email</h1>
          <p className="subtitle" style={{ color: '#666' }}>
            If an account exists for <strong>{email}</strong>, we sent a password reset link. It expires in 1 hour.
          </p>
          <p className="subtitle" style={{ color: '#666', marginTop: '1rem' }}>
            Don't see it? Check your spam folder.
          </p>
          <Link to="/login" className="btn btn-primary btn-block btn-large" style={{ backgroundColor: '#007AFF', textAlign: 'center', display: 'block', marginTop: '1.5rem', textDecoration: 'none', color: '#fff', padding: '12px', borderRadius: '8px' }}>
            Back to Sign In
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page" style={{ backgroundColor: '#FFFFFF' }}>
      <div className="auth-card">
        <h1 style={{ color: '#000' }}>Forgot password?</h1>
        <p className="subtitle" style={{ color: '#666' }}>Enter your email and we'll send you a reset link.</p>
        {error && <div className="alert alert-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label style={{ color: '#000' }}>Email</label>
            <input
              className="form-input"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="you@company.com"
              required
              autoFocus
            />
          </div>
          <button
            type="submit"
            className="btn btn-primary btn-block btn-large"
            style={{ backgroundColor: '#007AFF' }}
            disabled={loading}
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>
        <p className="switch-text" style={{ color: '#666' }}>
          Remember your password? <Link to="/login" style={{ color: '#007AFF' }}>Sign in</Link>
        </p>
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
